import {FormAction, VisaFN, VisaFormConfig, VisaFormName} from 'src/app/shared/models/forms';

//Model to represent the form config
export const VISA_FORM_CONFIG: VisaFormConfig = {
  [VisaFormName.PERSONAL_DETAILS]: {
    version: 0.1,
    classNames: 'gap_25',
    fields: [
      {name: VisaFN.PROVISIONAL_ENTRY_PORT, type: 'select', icon: 'location-dot', validators: [], showInResume: true},
      {name: VisaFN.PURPOSE_OF_VISIT, type: 'select', icon: 'question', validators: [], action: FormAction.SAVE, showInResume: true},
      {name: VisaFN.LAST_NAME, type: 'text', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.FIRST_NAME, type: 'text', icon: 'person', validators: [], showInResume: true},
      {name: VisaFN.OTHER_NAME, type: 'text', icon: 'person', validators: [], showInResume: true, tooltip: 'tooltip.otherName'},
      {name: VisaFN.BIRTH_DAY, type: 'date', icon: 'cake-candles', validators: [], showInResume: true},
      {name: VisaFN.GENDER, type: 'select', icon: 'venus-mars', enum: ['male', 'female'], validators: [], showInResume: true},
      {name: VisaFN.NATIONALITY, type: 'select', icon: 'globe', validators: [], showInResume: true},
      {name: VisaFN.EMAIL, type: 'text', icon: 'at', validators: [], showInResume: true}
    ]
  },
  [VisaFormName.TRAVEL_INFORMATION]: {
    version: 0.1,
    classNames: 'gap_25',
    textBeforeForm: {
      title: 'travel_information_title',
      text: 'travel_information_text'
    },
    fields: [
      {name: VisaFN.PASSPORT_TYPE, type: 'select', icon: 'passport', enum: ['ordinary', 'refugee', 'service', 'diplomatic', 'marine', 'laissez-passer', 'identity-card'], validators: [], showInResume: true},
      {name: VisaFN.PASSPORT_COUNTRY, type: 'select', icon: 'location-dot', showInResume: true, validators: []},
      {name: VisaFN.PASSPORT_NUMBER, type: 'text', validators: [], icon: 'passport', showInResume: true},
      {name: VisaFN.DATE_OF_EXPIRY, type: 'date', validators: [], showInResume: true}
    ]
  },
  [VisaFormName.DOCUMENT]: {
    version: 0,
    classNames: 'gap_8',
    textBeforeForm: {
      title: 'document',
      text: 'document_text'
    },
    fields: [
      {name: VisaFN.PASSPORT_PHOTO, type: 'file', icon: 'upload', acceptType: '.png,.jpg,.jpeg,.pdf', showInResume: true, maxFileSize: 1000 * 1000, action: FormAction.UPLOAD_FILE}
    ]
  }
};
